var t = require("react");

function n(t, n) {
  for (var r in n) {
    t[r] = n[r];
  }

  return t;
}

var r = {
  store: function store() {}
},
    o = function (n) {
  function r() {
    n.apply(this, arguments);
  }

  return n && (r.__proto__ = n), (r.prototype = Object.create(n && n.prototype)).constructor = r, r.prototype.getChildContext = function () {
    return {
      store: this.props.store
    };
  }, r.prototype.render = function () {
    return t.Children.only(this.props.children);
  }, r;
}(t.Component);

o.childContextTypes = r, exports.connect = function (o, e) {
  var i;
  return "function" != typeof o && ("string" == typeof (i = o || []) && (i = i.split(/\s*,\s*/)), o = function o(t) {
    for (var n = {}, r = 0; r < i.length; r++) {
      n[i[r]] = t[i[r]];
    }

    return n;
  }), function (i) {
    function c(r, c) {
      var p = this;
      t.Component.call(this, r, c);

      var u = c.store,
          s = o(u ? u.getState() : {}, r),
          f = e ? function (t, n) {
        "function" == typeof t && (t = t(n));
        var r = {};

        for (var o in t) {
          r[o] = n.action(t[o]);
        }

        return r;
      }(e, u) : {
        store: u
      },
          a = function a() {
        var t = o(u ? u.getState() : {}, r);

        for (var n in t) {
          if (t[n] !== s[n]) return s = t, p.forceUpdate();
        }

        for (var e in s) {
          if (!(e in t)) return s = t, p.forceUpdate();
        }
      };

      this.componentWillReceiveProps = function (t) {
        r = t, a();
      }, this.componentDidMount = function () {
        u.subscribe(a);
      }, this.componentWillUnmount = function () {
        u.unsubscribe(a);
      }, this.render = function () {
        return t.createElement(i, n(n(n({}, f), p.props), s));
      };
    }

    return c.contextTypes = r, (c.prototype = Object.create(t.Component.prototype)).constructor = c;
  };
}, exports.Provider = o;